<template>
  <div class="ui-content">
    <div class="ui-seachBox">
      <el-row class="row-bg">
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>姓名</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" clearable v-model="seach.tbName" placeholder="请输入姓名" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>电话</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" clearable v-model="seach.tbPhone" placeholder="请输入手机号" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>医院</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" filterable remote clearable v-model="seach.hospitalId" placeholder="请输入医院名称后选择" :remote-method="remoteMethod" :loading="loading">
            <el-option v-for="item in hospitalList" :key="item.tbId" :label="item.tbHospitalName" :value="item.tbId"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="row-bg">
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>是否添加微信</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" clearable v-model="seach.tbIsAddWx" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>选择时间</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-date-picker class="ui-seachBox-input" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="time" type="datetimerange" range-separator="至" start-placeholder="" end-placeholder="">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <p class="ui-seachBox-label">
            <span>类型</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" v-model="seach.searchType" placeholder="请选择">
            <el-option label="全部孕妈" :value="0"></el-option>
            <el-option label="已下单" :value="1"></el-option>
            <el-option label="有监测数据" :value="2"></el-option>
            <el-option label="怀孕中" :value="3"></el-option>
            <el-option label="已出生" :value="4"></el-option>
          </el-select>
        </el-col>
        <el-button class="ui-seachBox-submit" type="primary" @click="getList" v-has="pathCode+':seach'">查 询</el-button>
        <el-button class="ui-seachBox-reset" @click="reset" v-has="pathCode+':reset'">重 置</el-button>
      </el-row>
    </div>
    <div class="ui-tableBox">
      <div class="ui-tableBox-bar">
        <p class="ui-tableBox-title">数据列表</p>
      </div>
      <div class="ui-tableList">
        <el-table v-loading="loading" :data="tableList" :max-height="tableHeight" :default-sort="{prop: 'tbSort', order: 'ascending'}" border style="width: 100%" :header-cell-style="{background: '#FAFAFA'}">
          <el-table-column align="center" prop="username" label="姓名">
          </el-table-column>
          <el-table-column align="center" prop="phone" label="手机">
          </el-table-column>
          <el-table-column align="center" prop="tbHospitalName" label="医院" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="是否出生">
            <template slot-scope="{row}">
              {{row.currentGeneration == 2?'已出生':'未出生'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tbBirthday" label="预产期/生日">
            <template slot-scope="{row}">
              {{new Date(row.tbBirthday).format('yyyy-MM-dd')}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="设备">
            <template slot-scope="{row}">
              {{getEquipmentTypeName(row.tbEquipmentType)}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="今日胎心">
            <template slot-scope="{row}">
              {{row.tbCardiacRate?Number(row.tbCardiacRate)+'bpm':'暂无'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="今日黄疸">
            <template slot-scope="{row}">
              {{row.tbJaundiceValue?Number(row.tbJaundiceValue)+'mg/dl':'暂无'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="lastTime" label="上次维护时间">
            <template slot-scope="{row}">{{row.lastTime?row.lastTime:'无'}}</template>
          </el-table-column>
          <el-table-column align="center" prop="tbMaintainStatus" label="维护状态">
            <template slot-scope="{row}">{{statusMap[row.tbMaintainStatus]}}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="操作">
            <template slot-scope="{row}">
              <el-row>
                <el-link class="ui-tableList-link" v-has="pathCode+':edit'" @click="openTab('客户信息',detailName,`${filePath}/${detailName}`,{tbId:row.id})">编辑</el-link>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
    </div>
  </div>
</template>
<script>
const files = require.context('/', false, /\.vue$/)
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2)
const fileName = 'all'
const controller = 'user'
import { debounceUtils } from '@/utils/common.js'
import { mapGetters } from 'vuex'
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this
    return {
      pathCode: `${suffixList.join('')}${fileName}`,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      detailName: `${fileName}Detail`,
      loading: true,
      tableHeight: null,
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.getList()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.getList()
        }
      },
      equipmentList: [

      ],
      statusList: [
        { id: 0, name: '未维护' },
        { id: 1, name: '未接通' },
        { id: 2, name: '拒绝沟通' },
        { id: 3, name: '维护中' },
        { id: 4, name: '已结束' }
      ],
      tableList: [],
      hospitalList: [],
      time: [],
      seach: {
        tbName: '',
        tbPhone: '',
        hospitalId: '',
        tbStartTime: '',
        tbStopTime: '',
        tbIsAddWx: '',
        searchType: 0
      }
    }
  },
  computed: {
    equipmentMap () {
      return this.equipmentList.reduce((res, { tbId, tbName }) => {
        res[tbId] = tbName
        return res
      }, {})
    },
    statusMap () {
      return this.statusList.reduce((res, { id, name }) => {
        res[id] = name
        return res
      }, {})
    },
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.getList()
        this.$store.dispatch('setRefreshPage', false)
      }
    }
  },
  methods: {
    getEquipmentTypeList () {
      this.$http.get(`/tbGoodsEquipmentType/findList`, {}).then((res) => {
        if (res.code === 1000) {
          this.equipmentList = res.data
        }
      })
    },
    getEquipmentTypeName (ids) {
      if (!ids) {
        return '暂无'
      } else {
        const name = Array.from(new Set(ids.split(','))).filter(i => i != 0).reduce((res, i) => {
          return res += this.equipmentMap[i] + ','
        }, '').replace(/,$/, '')
        return name ? name : '暂无'
      }
    },
    remoteMethod (name) {
      if (name !== '') {
        this.loading = true
        this.$http.get(`/hospital/findList`, { name })
          .then(res => {
            this.loading = false
            if (res.code === 1000) {
              this.hospitalList = res.data
            } else {
              this.$message.error(res.message)
            }
          })
      } else {
        this.hospitalList = []
      }
    },
    reset () {
      this.seach = {
        tbName: '',
        tbPhone: '',
        hospitalId: '',
        tbStartTime: '',
        tbStopTime: '',
        tbIsAddWx: '',
        searchType: 0
      }
      this.time = []
    },
    getList: debounceUtils(function () {
      this.loading = true
      this.seach.page = this.page.currentPage
      this.seach.size = this.page.pageSize
      if (this.time && this.time.length === 2) {
        this.seach.tbStartTime = this.time[0]
        this.seach.tbStopTime = this.time[1]
      } else {
        delete this.seach.tbStartTime
        delete this.seach.tbStopTime
      }
      this.$http.get(`/${controller}/findCustomerAll`, this.seach).then((res) => {
        this.loading = false
        if (res.code === 1000) {
          this.tableList = res.data.list
          this.page.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    }, 500)
  },
  destroyed () {
    this.destroyResizeListen(500)
  },
  created () {
    this.addResizeListen(500)
  },
  mounted () {
    this.getList()
    this.getEquipmentTypeList()
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-seachBox {
    margin: 0 24px 24px;
    width: calc(100% - 48px);
    height: 136px;
    background: #ffffff;
    border-radius: 2px;
    .row-bg {
      padding: 24px 24px 0;
      .ui-seachBox-label {
        display: inline-block;
        text-align: right;
        width: 100px;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-label2 {
        display: inline-block;
        text-align: right;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
        margin-right: 10px;
      }
      .ui-seachBox-box-switch {
        height: 32px;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-Symbol {
        margin-left: 3px;
        margin-right: 5px;
      }
      .ui-seachBox-input {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding-top: 0;
        padding-bottom: 0;
        vertical-align: middle;
        ::v-deep .el-icon-circle-close,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-range__icon,
        ::v-deep .el-range-separator,
        ::v-deep .el-range-input,
        ::v-deep .el-range__close-icon,
        ::v-deep .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
      }
      .ui-seachBox-box-label {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        line-height: 32px;
      }
    }
    .ui-seachBox-reset {
      margin: 0 0 0 8px;
      float: right;
      border-radius: 2px;
      padding: 9px 15px;
      &:focus {
        outline: none;
      }
    }
    .ui-seachBox-submit {
      padding: 9px 15px;
      margin: 0 24px 0 8px;
      float: right;
      border-radius: 2px;
      &:focus {
        outline: none;
      }
    }
  }
  .ui-tableBox {
    margin: 0 24px;
    width: calc(100% - 48px);
    background: #ffffff;
    border-radius: 2px;
    height: calc(100% - 184px);
    position: relative;
    .ui-tableBox-bar {
      position: relative;
      margin: 0 24px;
      height: 64px;
      .ui-tableBox-title {
        height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        display: inline-block;
        margin-top: 20px;
      }
      .ui-tableBox-button {
        width: 108px;
        position: relative;
        float: right;
        top: 16px;
        margin-left: 24px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.export {
          padding: 8px 15px;
          width: auto;
        }
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-input__inner {
          height: 30px;
          line-height: 30px;
          border: none;
          &::-webkit-input-placeholder {
            color: #606266;
          }
          &::-moz-placeholder {
            color: #606266;
          }
          &::-ms-input-placeholder {
            color: #606266;
          }
        }
        &:focus {
          outline: none;
        }
      }
    }
    .ui-tableList {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      margin: 8px 24px 0 24px;
      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      .ui-box-tableList-label {
        margin: 0 5px 10px;
      }
      .ui-box-tableList-editImg {
        width: 43px;
        cursor: pointer;
        height: 43px;
      }
      .ui-box-tableList-tempSaveImg {
        width: 41px;
        height: 41px;
        position: absolute;
        left: -2px;
        top: -3px;
      }
      ::v-deep .el-table__body-wrapper {
        height: auto !important;
      }
      .ui-tableList-button {
        padding: 9px 17px;
        outline: none;
      }
      .ui-tableList-link.is-underline:hover:after {
        border: none;
      }
    }
  }
}
</style>